<template>
  <div class="today-alarm">
    <resize-container :tabShow="tabShow">
      <div class="grid-content" slot="left" v-show="tabShow">
        <tab-tree
          :data="viewTreeData"
          @changeCompany="changeCompany"
          @tabTreeDefault="tabTreeDefault"
          @tabTreeClick="tabTreeClick"
        ></tab-tree>
      </div>
      <div class="grid-rightcontent">
        <data-type
          style="box-sizing: border-box;border-radius: 5px;"
          ref="search"
          @getData="bindgetSearchElem"
          :timeType="timeType"
          inputSize="mini"
        >
          <label style="margin-left:6px;">谐波：</label>
          <el-select size="mini" style="width:150px;" v-model="harmonic">
            <el-option
              v-for="(obj, index) in computedNum"
              :key="index"
              :label="obj.label"
              :value="obj.value"
            ></el-option>
          </el-select>
        </data-type>

        <div class="pane">
          <nk-chart
            style="margin-bottom:14px"
            :data="chartDataV"
            :timeTitle="timeTitle"
            :showTitle="false"
            unit="%"
          ></nk-chart>
          <nk-chart
            style="margin-bottom:14px"
            :data="chartDataA"
            :timeTitle="timeTitle"
            :showTitle="false"
            unit="%"
          ></nk-chart>
          <div class="bg-box box-magin" style="margin-bottom: 14px;">
            电压谐波畸变率控制在5%以内<br />
            电流谐波畸变率控制在5%以内
          </div>
          <div style="width:100%;box-magin;height: 400px;">
            <nk-table
              :showPage="false"
              :columns="columns"
              :data="tableData"
            ></nk-table>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import TabTree from "@/components/common/TabTree.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import api from "@common/api/index.js";
import { findDataByParam } from "@/utils/index.js";
import handleData from "@/utils/handleData.js";
import DataType from "@/components/common/datatype";
import NkTable from "@/components/common/NkTable.vue";
import NkChart from "@/components/common/NkChart18.vue";
import ResizeContainer from "@/components/common/resizeContainer.vue";
export default {
  components: {
    TabTree,
    BtnShow,
    DataType,
    NkTable,
    NkChart,
    ResizeContainer,
  },
  computed: {
    computedNum() {
      let arr = [{ label: "总谐波", value: 0 }];
      for (let i = 2; i < 65; i++) {
        arr.push({
          label: "第" + this.toChinesNum(i) + "次谐波",
          value: i,
        });
      }
      return arr;
    },
  },
  data() {
    return {
      tabShow: true,
      viewTreeData: [],
      selectedMeasure: {
        measureId: "",
        measureName: "",
      },
      timeType: [
        { value: "0", label: "日" },
        // { value: "2", label: "月" },
        // { value: "3", label: "时段" },
        // { value: "5", label: "年" },
      ],
      harmonic: 0,
      columns: [
        { prop: "measureName", width: 250, label: "监测点名称" },
        { prop: "title", label: "相序" },
        { prop: "max", label: "最大谐波畸变率" },
        { prop: "maxTime", label: "最大谐波畸变率发生时间" },
        { prop: "min", label: "最小谐波畸变率" },
        { prop: "minTime", label: "最小谐波畸变率发生时间" },
      ],
      tableData: [],
      chartDataV: [],
      chartDataA: [],
      unit: "",
      timeTitle: "",
      showEleWork: false,
      eleWorkObj: {},
      measure: [],
      isDoubleY: false,
      selectNodes: [],
    };
  },
  created() {
    let vm = this;
  },
  mounted() {
    async function testAsync() {
      return "hello async";
    }
    const result = testAsync();
    console.log(result);
  },
  methods: {
    toChinesNum(num) {
      let changeNum = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = (temp) => {
        let strArr = temp
          .toString()
          .split("")
          .reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i == 0 && strArr[i] == 0
              ? ""
              : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
              ? ""
              : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
            newNum;
        }
        return newNum;
      };
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) {
        noWan = "0" + noWan;
      }
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },
    changeCompany(companyId) {
      api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(companyId, "/power/Harmonic2", null)
        .then((res) => {
          const viewTreeData = findDataByParam("viewTree", true, res.data);
          this.viewTreeData = viewTreeData;
        });
    },

    tabTreeDefault(e) {
      let vm = this;
      vm.selectedMeasure = e;
      let defaultNode = e;
      vm.selectNodes = [
        { id: defaultNode.measureId, label: defaultNode.measureName },
      ];

      vm.elem = vm.$refs.search.getElem();
      vm.getData();
    },
    tabTreeClick(data) {
      let vm = this;
      vm.selectNodes = [{ id: data.measureId, label: data.measureName }];

      vm.elem = vm.$refs.search.getElem();
      vm.getData();
    },

    bindgetSearchElem(e) {
      this.elem = e;
      this.getData();
    },

    getData() {
      const HARMONIC_VOLTAGE_A = 10000, //谐波电压A
        HARMONIC_VOLTAGE_B = 15000, //谐波电压B
        HARMONIC_VOLTAGE_C = 20000, //谐波电压C
        HARMONIC_CURRENT_A = 25000, //谐波电流A
        HARMONIC_CURRENT_B = 30000, //谐波电流B
        HARMONIC_CURRENT_C = 35000;
      let harmonic = parseInt(this.harmonic);
      let codes = [
        {
          code: HARMONIC_VOLTAGE_A + harmonic,
          title: "A相电压谐波畸变率",
          show: true,
        },
        {
          code: HARMONIC_VOLTAGE_B + harmonic,
          title: "B相电压谐波畸变率",
          show: true,
        },
        {
          code: HARMONIC_VOLTAGE_C + harmonic,
          title: "C相电压谐波畸变率",
          show: true,
        },
        {
          code: HARMONIC_CURRENT_A + harmonic,
          title: "A相电流谐波畸变率",
          show: true,
        },
        {
          code: HARMONIC_CURRENT_B + harmonic,
          title: "B相电流谐波畸变率",
          show: true,
        },
        {
          code: HARMONIC_CURRENT_C + harmonic,
          title: "C相电流谐波畸变率",
          show: true,
        },
      ];
      this.getQuantityData(codes);
      this.getMaxMin(codes);
    },
    getQuantityData(codes) {
      let vm = this;
      let measures = [];
      for (let index = 0; index < vm.selectNodes.length; index++) {
        const element = vm.selectNodes[index];
        for (let j = 0; j < codes.length; j++) {
          measures.push({
            measureId: element.id,
            pointNumber: 0,
            pointCode: codes[j].code,
          });
        }
      }
      vm.$api.measuring
        .getMeasuringValueAll2(measures, vm.elem.fromDate, vm.elem.toDate, 0, 0)
        .then((res) => {
          vm.showData(
            vm.activeName,
            vm.elem,
            res.data,
            vm.selectNodes,
            codes,
            2
          );
        });
    },

    showData(activeName, elem, data, selectNodes, codes, arrType) {
      let vm = this;
      // let xData = handleData.createXData(
      //   elem.dateType,
      //   elem.fromDate,
      //   elem.toDate
      // );
      let dType = "";
      switch (elem.dateType) {
        case "0":
          dType = "h";
          break;
        case "2":
          dType = "d";
          break;
        case "3":
          console.log("elem.toDate", elem.toDate);
          let differ =
            new Date(elem.toDate).getTime() - new Date(elem.fromDate).getTime();
          if (differ < 3600 * 1000 * 24 * 3) {
            dType = "h";
          } else {
            dType = "d";
          }
          break;
        case "5":
          dType = "m";
          break;
      }

      let chartData = handleData.matchMeasuringData(
        data,
        selectNodes,
        codes,
        3,
        1
      );

      let chartDataV = [
        {
          xData: chartData[0].xData,
          title: chartData[0].title + "-电压谐波畸变率",
          tip: chartData[0].tip.slice(0, 3),
          selected: chartData[0].selected,
          data: chartData[0].data.slice(0, 3),
        },
      ];
      let chartDataA = [
        {
          xData: chartData[0].xData,
          title: chartData[0].title + "-电流谐波畸变率",
          tip: chartData[0].tip.slice(3, 6),
          selected: chartData[0].selected,
          data: chartData[0].data.slice(3, 6),
        },
      ];

      vm.timeTitle = elem.fromDate + "~" + elem.toDate;
      vm.chartDataA = chartDataA;
      vm.chartDataV = chartDataV;
    },
    /**
     * 查询瞬时数据最大值最小值
     */
    getMaxMin(codes) {
      let vm = this;
      let maxMinParams = [];
      let dType = "";
      let isType3 = false;

      switch (vm.elem.dateType) {
        case "0":
          dType = "h";
          for (let index = 0; index < vm.selectNodes.length; index++) {
            const element = vm.selectNodes[index];
            for (let j = 0; j < codes.length; j++) {
              maxMinParams.push(
                vm.$api.measuring.getMeasuringValueMaxMinDay(
                  element.id,
                  vm.elem.fromDate,
                  vm.elem.toDate,
                  codes[j].code,
                  "0"
                )
              );
            }
          }
          break;
        case "2":
          dType = "m";
          for (let index = 0; index < vm.selectNodes.length; index++) {
            const element = vm.selectNodes[index];
            for (let j = 0; j < codes.length; j++) {
              maxMinParams.push(
                vm.$api.measuring.getMeasuringValueMaxMinMonth(
                  element.id,
                  vm.elem.fromDate,
                  vm.elem.toDate,
                  codes[j].code,
                  "0"
                )
              );
            }
          }
          break;
        case "3":
          isType3 = true;
          console.log("elem.toDate", vm.elem.toDate);
          let differ =
            new Date(vm.elem.toDate).getTime() -
            new Date(vm.elem.fromDate).getTime();
          if (differ <= 3600 * 1000 * 24 * 3) {
            dType = "h";
            for (let index = 0; index < vm.selectNodes.length; index++) {
              const element = vm.selectNodes[index];
              for (let j = 0; j < codes.length; j++) {
                maxMinParams.push(
                  vm.$api.measuring.getMeasuringValueMaxMin(
                    element.id,
                    vm.elem.fromDate,
                    vm.elem.toDate,
                    codes[j].code,
                    "0"
                  )
                );
              }
            }
          } else {
            dType = "d";
            for (let index = 0; index < vm.selectNodes.length; index++) {
              const element = vm.selectNodes[index];
              for (let j = 0; j < codes.length; j++) {
                maxMinParams.push(
                  vm.$api.measuring.getMeasuringValueMaxMin(
                    element.id,
                    vm.elem.fromDate,
                    vm.elem.toDate,
                    codes[j].code,
                    "0"
                  )
                );
              }
            }
          }
          break;
        case "5":
          dType = "y";
          for (let index = 0; index < vm.selectNodes.length; index++) {
            const element = vm.selectNodes[index];
            for (let j = 0; j < codes.length; j++) {
              maxMinParams.push(
                vm.$api.measuring.getMeasuringValueMaxMinYear(
                  element.id,
                  vm.elem.fromDate,
                  vm.elem.toDate,
                  codes[j].code,
                  "0"
                )
              );
            }
          }
          break;
      }
      Promise.all(maxMinParams).then((arr) => {
        let data = handleData.handleMaxMin(
          arr,
          vm.selectNodes,
          codes,
          dType,
          isType3,
          3,
          100
        );
        console.log("🚀 ~ file: Harmonic2.vue:454 ~ Promise.all ~ data:", data);
        vm.tableData = data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .echarts-warp {
  padding: 0px !important;
  border: none !important;
}
::v-deep .echart-content {
  padding-top: 20px !important;
}
.today-alarm {
  padding: 14px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
}
.person {
  height: 100%;
}
.grid-content {
  position: relative;
  height: 100%;
  background: #d5dadd;
  color: rgba(24, 24, 24, 1);
  overflow: auto;
  border-radius: 4px;
}
.grid-rightcontent {
  position: relative;
  height: 100%;
  color: rgba(24, 24, 24, 1);
  display: flex;
  flex-direction: column;
  .timeselect {
    padding: 5px 10px;
  }
  .pane {
    text-align: left;
    padding: 15px 0px;
    overflow: auto;
  }
  .bg-box {
    background: #fff;
    border-radius: 4px;
    padding: 14px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    border: 1px solid #dedcdc;
  }
}
.toptitle {
  color: #fff;
  font-weight: bold;
  display: flex;
  padding: 5px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  font-size: 16px;
  justify-content: space-between;
}
.top {
  flex: 1;
  .topleftcontent {
    background: #fff;
    border: 1px solid #eee;
    height: 12vh;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .topmiddlecontent {
    // background: #fff;
    // margin:5px;
    height: 11vh;
  }
  .toprightcontent {
    height: 11vh;
  }
  .Toprightcontent {
    background: #f0f3f4;
    border-radius: 4px;
    width: 100%;
    white-space: normal;
    line-height: 24px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    // font-weight: bold;
    position: relative;
    height: 10.5vh;
    text-overflow: ellipsis;
    margin: 6px 0px 0px -9px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .ts {
    position: absolute;
    top: 5%;
    left: 60%;
    width: 1.5vw;
    height: 6.5vh;
    line-height: 2.6vh;
    font-size: 0.8rem;
    text-align: center;
    background: #05cfb5;
    writing-mode: vertical-lr;
    color: azure;
    border-radius: 10px;
  }
  .middlecontent {
    // background: #f0f3f4;
    display: flex;
    align-items: center;
    justify-content: center;
    // margin: 5px;
    height: 11vh;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .rightcontent {
    // background: #f0f3f4;
    display: flex;
    align-items: center;
    justify-content: center;
    // margin: 5px;
    height: 11vh;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .titlebox {
    display: flex;
    width: 30%;
    justify-content: space-around;
    align-items: center;
    // flex: 1;
    // flex-flow: row;
    // width: 50px;
    // height: 50px;
  }
  .content {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    font-size: 0.7rem;
    // margin: 7px 0 0 9px;
    span:nth-child(2) {
      margin-top: 10px;
      color: #111;
      font-size: 1.5rem;
      font-weight: bold;
    }
  }
}
.middle {
  flex: 0.1;
  margin: 14px 0;
  .middleselect {
    display: flex;
    // background: #fff;
    height: 4.5vh;
    border-radius: 4px;
    padding: 6px;
    box-sizing: border-box;
  }
}
.bottom {
  flex: 5;
  display: flex;
  flex-flow: column;
  .topLineChartLeft {
    flex: 1;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .topLineChartRight {
    flex: 1;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .bottomLineChartLeft {
    flex: 1;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .bottomLineChartRight {
    flex: 1;
    background: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.guanBox {
  width: 100%;
  height: 100%;
}
::v-deep .tabTree-wrap[data-v-bd1aa9c2] {
  background: #fff;
}
.hglfont {
  // width: 53px;
  // height: 26px;
  position: absolute;
  top: 90%;
  left: 41%;
  font-size: 1.5rem;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #206ee3;
  display: flex;
  justify-content: center;
}
.radiostle {
  margin: auto;
  margin-left: 0;
}
.selectone {
  margin: auto 20px;
}
.xbTitle {
  background: #04b39c;
  height: 50px;
  width: 50px;
  line-height: 50px;
  border-radius: 100%;
  color: #fff;
  font-size: 20px;
}
.bottom-top {
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  overflow: hidden;
}
.fc {
  margin-right: 8px;
}
.ye {
  color: #f86666;
}
.he {
  color: #3dc8b5;
}
</style>
